/**
 * @description: 路由
 * @author: nowThen
 */

import Vue from 'vue';
import Router from 'vue-router';

const Error = () => import(/* webpackChunkName: "error" */ '@/views/error');
const Layout = () => import(/* webpackChunkName: "apply" */ '@/views/layout/layout')
const LayoutBlank = () => import(/* webpackChunkName: "apply" */ '@/views/layout/layoutBlank')

Vue.use(Router);

const routes = [
  {
    path: '/error',
    name: 'error',
    component: Error,
    meta: {
      title: '404页'
    }
  },
  {
    path: '*',
    redirect: 'error',
  },
  {
    path: '/',
    redirect: { name: 'index' }
  },
  {
    path: '/terrace',
    name: 'terrace',
    component: () => import('@/views/content/terrace'),
    meta: {
      title: '管理平台', // 标题
      requireAuth: false, // 登录权限
    }
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/content/index'),
        name: 'index',
        meta: {
          title: '首页', // 标题
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'glykt',
        component: () => import('@/views/content/Glingyuan'),
        name: 'glykt',
        meta: {
          title: '格灵元课堂-格如灵科技', // 标题
          keyWords: '格灵元课堂,格如灵,格如灵科技',
          description: '格灵元课堂提供元宇宙教育一体化解决方案平台，格灵元课堂支持元宇宙多场景应用，资源、管理、创作、远程教育等。格灵元课堂是虚拟与现实全面交织、人与机器全面协同、学校与社会全面连接的元宇宙教育平台。',
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'plan',
        component: () => import('@/views/content/planDetail'),
        name: 'plan',
        meta: {
          title: '方案详情', // 标题
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'product',
        component: () => import('@/views/content/product'),
        name: 'product',
        meta: {
          title: '首页', // 标题
          active: 'student',
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'middleProduct',
        component: () => import('@/views/content/middleProduct'),
        name: 'middleProduct',
        meta: {
          title: '首页', // 标题
          active: 'student',
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'jiang',
        component: () => import('@/views/content/jiang'),
        name: 'jiang',
        meta: {
          title: '灵匠', // 标题
          active: 'career',
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'dian',
        component: () => import('@/views/content/dian'),
        name: 'dian',
        meta: {
          title: '灵点', // 标题
          requireAuth: false, // 登录权限
          active: 'datePlatform'
        }
      },
      // {
      //   path: 'pay',
      //   component: () => import('@/views/marketing/pay'),
      //   name: 'pay',
      //   meta: {
      //     title: '付费资源', // 标题
      //     requireAuth: false, // 登录权限
      //     active: 'product'
      //   }
      // },
      {
        path: 'chuang',
        component: () => import('@/views/content/chuang'),
        name: 'chuang',
        meta: {
          title: '灵创', // 标题
          requireAuth: false, // 登录权限
          active: 'student'
        }
      },
      {
        path: 'world',
        component: () => import('@/views/content/world'),
        name: 'world',
        meta: {
          title: '格林世界', // 标题
          requireAuth: false, // 登录权限
          active: 'student'
        }
      },
      {
        path: 'productDetail',
        component: () => import('@/views/content/productDetail'),
        name: 'productDetail',
        meta: {
          title: '产品', // 标题
          requireAuth: false, // 登录权限
          active: 'career'
        }
      },
      {
        path: 'hardware',
        component: () => import('@/views/content/hardware'),
        name: 'hardware',
        meta: {
          title: '硬件产品', // 标题
          requireAuth: false, // 登录权限
          active: 'product'
        }
      },
      {
        path: 'history',
        component: () => import('@/views/content/history'),
        name: 'history',
        meta: {
          title: '公司历史', // 标题
          requireAuth: false, // 登录权限
          active: 'about'
        }
      },
      {
        path: 'wisdom',
        component: () => import('@/views/content/wisdom'),
        name: 'wisdom',
        meta: {
          title: '智慧宫', // 标题
          active: 'student',
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'abstract',
        component: () => import('@/views/content/abstract'),
        name: 'abstract',
        meta: {
          title: '公司介绍', // 标题
          requireAuth: false, // 登录权限
          active: 'about'
        }
      },
      {
        path: 'eg',
        component: () => import('@/views/content/eg'),
        name: 'eg',
        meta: {
          title: '成功案例', // 标题
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'news',
        component: () => import('@/views/content/news'),
        name: 'news',
        meta: {
          title: '公司资讯', // 标题
          active: 'news',
          keepAlive: true,
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'newsDetail',
        component: () => import('@/views/content/newsDetail'),
        name: 'newsDetail',
        meta: {
          title: '新闻详情', // 标题
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'policy',
        component: () => import('@/views/content/policy'),
        name: 'policy',
        meta: {
          title: '最新政策', // 标题
          active: 'policy',
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'honors',
        component: () => import('@/views/content/honors'),
        name: 'honors',
        meta: {
          title: '荣誉资质', // 标题
          active: 'about',
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'example',
        component: () => import('@/views/content/example'),
        name: 'example',
        meta: {
          title: '解决方案整合', // 标题
          active: 'example',
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'customerStories',
        component: () => import('@/views/content/customerStories'),
        name: 'customerStories',
        meta: {
          title: '客户成功案例', // 标题
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'cooperation',
        component: () => import('@/views/content/cooperation'),
        name: 'cooperation',
        meta: {
          title: '业务合作', // 标题
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'joinUs',
        component: () => import('@/views/content/joinUs'),
        name: 'joinUs',
        meta: {
          title: '业务合作', // 标题
          active: 'about',
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'service',
        component: () => import('@/views/content/service'),
        name: 'service',
        meta: {
          title: '客户服务', // 标题
          active: 'product',
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'productCenter',
        component: () => import('@/views/content/productCenter'),
        name: 'productCenter',
        meta: {
          title: '产品中心', // 标题
          active: 'product',
          requireAuth: false, // 登录权限
        }
      },
    ]
  },
  {
    path: '/collect',
    component: LayoutBlank,
    children: [
      {
        path: 'jiang',
        component: () => import('@/views/collect/jiangRegister'),
        name: 'jiangRegister',
        meta: {
          title: '灵匠', // 标题
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'jiangList',
        component: () => import('@/views/collect/jiangRegisterList'),
        name: 'jiangRegisterList',
        meta: {
          title: '灵匠', // 标题
          requireAuth: false, // 登录权限
        }
      }
    ]
  },
  {
    path: '/marketing',
    component: LayoutBlank,
    children: [
      {
        path: 'mechanical',
        name: 'mechanical',
        component: () => import('@/views/marketing/mechanical')
      },
      {
        path: 'school',
        name: 'marketingSchool',
        component: () => import('@/views/marketing/school')
      },
      {
        path: 'wisdom',
        name: 'marketingWisdom',
        component: () => import('@/views/marketing/wisdom')
      },
      {
        path: 'education',
        name: 'education',
        component: () => import('@/views/marketing/education')
      },
      {
        path: 'futureclass',
        name: 'futureclass',
        component: () => import('@/views/marketing/futureclass')
      },
    ]
  },
  {
    path: '/education',
    component: LayoutBlank,
    children: [
      {
        path: 'login',
        component: () => import('@/views/education/login'),
        name: 'educationLogin',
        meta: {
          title: '考试登录', // 标题
          requireAuth: false, // 登录权限
        }
      }
    ]
  },
  {
    path: '/education/exam',
    component: () => import('@/views/education/exam/layout'),
    name: 'exam',
    meta: {
      title: '考试开始', // 标题
      requireAuth: false, // 登录权限
    },
    children: [
      {
        path: 'video',
        component: () => import('@/views/education/exam/video'),
        name: 'educationVideo',
        meta: {
          title: '视频考试', // 标题
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'darg',
        component: () => import('@/views/education/exam/darg'),
        name: 'educationDarg',
        meta: {
          title: '拖拽考试', // 标题
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'record',
        component: () => import('@/views/education/exam/record'),
        name: 'educationRecord',
        meta: {
          title: '录音考试', // 标题
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'darwing',
        component: () => import('@/views/education/exam/darwing'),
        name: 'educationDarwing',
        meta: {
          title: '画板考试', // 标题
          requireAuth: false, // 登录权限
        }
      }
    ]
  },
  {
    path: '/test',
    component: () => import('@/views/collect/test'),
    name: 'test',
    meta: {
      title: '测试', // 标题
      requireAuth: false, // 登录权限
    }
  }
];

const router = new Router({
  mode: 'history',
  routes
})

export default router;
